import { createSlice } from '@reduxjs/toolkit';
import {
  addUfVisualObs,
  fetchMetalTypes,
  fetchUfStages,
  fetchUfVisualTypes,
  fetchUnderFrameType,
  fetchAllUnderFrameType,
  addVisualTypes,
  deleteVisualType,
  fetchAllUser,
  deleteUser,
  fetchRitesSupUser,
  fetchAirBrakePoints,
} from './frametypeThunk';

const initialState = {
  uf_types: [],
  metal_types: [],
  uf_stages: [],
  uf_visual_types: [],
  loading: false,
  error: null,
  fetch_rites_sup_users: [],
  air_brake_points: [],
  all_uf_types: [],
};

const frametypeSlice = createSlice({
  name: 'frametype',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchUnderFrameType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUnderFrameType.fulfilled, (state, action) => {
        state.loading = false;
        state.uf_types = action.payload.data;
      })
      .addCase(fetchUnderFrameType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch FrameTypes';
      })
      .addCase(fetchAllUnderFrameType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllUnderFrameType.fulfilled, (state, action) => {
        state.loading = false;
        state.all_uf_types = action.payload.data;
      })
      .addCase(fetchAllUnderFrameType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch FrameTypes';
      })
      //
      .addCase(fetchUfStages.fulfilled, (state, action) => {
        state.loading = false;
        state.uf_stages = action.payload.data;
      })

      .addCase(fetchUfVisualTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.uf_visual_types = action.payload.data;
      })

      .addCase(fetchMetalTypes.fulfilled, (state, action) => {
        state.loading = false;
        state.metal_types = action.payload.data;
      })
      .addCase(addUfVisualObs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addUfVisualObs.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Visual obs saved successfully';
      })
      .addCase(addUfVisualObs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.Payload;
      })

      .addCase(addVisualTypes.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(addVisualTypes.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Visual Type saved successfully';
      })
      .addCase(addVisualTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.Payload;
      })

      .addCase(deleteVisualType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteVisualType.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'Visual type deleted successfully';
      })
      .addCase(deleteVisualType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to delete Visual type';
      })

      .addCase(fetchAllUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAllUser.fulfilled, (state, action) => {
        state.loading = false;

        console.log('Payload:', action.payload);

        state.all_users = action.payload.data;
      })
      .addCase(fetchAllUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(deleteUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteUser.fulfilled, (state) => {
        state.loading = false;
        state.successMessage = 'User deleted successfully';
      })
      .addCase(deleteUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to delete User';
      })
      .addCase(fetchRitesSupUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchRitesSupUser.fulfilled, (state, action) => {
        state.loading = false;

        console.log('Payload rites subbbbb:', action.payload);

        state.fetch_rites_sup_users = action.payload.data;
      })
      .addCase(fetchRitesSupUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchAirBrakePoints.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAirBrakePoints.fulfilled, (state, action) => {
        state.loading = false;
        state.air_brake_points = action.payload.data;
      })
      .addCase(fetchAirBrakePoints.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || 'Failed to fetch FrameTypes';
      });
  },
});

export default frametypeSlice.reducer;
